<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div class="scarf">
    <NavBar />
    <h3 class="title">
      Tu peux voir l'ensemble des foulard des autres scouts, guides, éclaireurs et éclaireuses arrivées avant toi !
    </h3>
    <ul style="margin-bottom=150px">
      <li :id="'foulard-li-' + scarf.id" class="otherFoulard" v-for="scarf in scarfs" :key="scarf.id">
        <Foulard :onload="changeColor(scarf, 0)" :id="'foulard-' + scarf.id" />
      </li>
    </ul>
  </div>
</template>

<style>
.title {
  margin-top: 20px;
  margin-bottom: 20px;
}
.otherFoulard {
  margin-top: 100px;
  position: relative;
  display: inline-block;
  margin: 10px 0 0 10px;
  width: 66px;
  height: 100px;
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear;
}
</style>

<script>
// @ is an alias to /src
import Foulard from "@/components/foulard.svg";
import ApiService from "@/services/ApiService";
import NavBar from "@/components/NavBar.vue";
export default {
  name: "Scarf",
  data: function () {
    return {
      scarfs: []
    };
  },
  created: async function () {
    const AllResp = await ApiService.get(`/scarfs/random/1000`);
    this.scarfs = AllResp.data.scarfs;
  },
  methods: {
    changeColor: function (scarf, delay) {
      if (delay === 0) {
        delay = Math.floor(Math.random() * 1000 + 1000);
      }
      setTimeout(function () {
        let a = document.getElementById("foulard-" + scarf.id);
        if (!a) return;
        let fond = a.getElementById("fond-foulard");
        fond.setAttribute("fill", scarf.background_color);
        let lisere = a.getElementById("lisere-foulard");
        lisere.setAttribute("fill", scarf.border_color);
        let bague = a.getElementById("bague-foulard");
        bague.setAttribute("fill", scarf.background_color);

        let b = document.getElementById("foulard-li-" + scarf.id);
        b.style.visibility = "visible";
        b.style.opacity = "1";
      }, delay);
    }
  },
  components: {
    Foulard,
    NavBar
  }
};
</script>
